import { render } from "./titleContentBlock.vue?vue&type=template&id=14c94520&scoped=true"
import script from "./titleContentBlock.vue?vue&type=script&lang=js"
export * from "./titleContentBlock.vue?vue&type=script&lang=js"

import "./titleContentBlock.vue?vue&type=style&index=0&id=14c94520&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14c94520"]])

export default __exports__